import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

/**
 * Generic Grid System for tables on Reports. Has nice sticky header for long content.
 *
 * @example
 *    <div className={tableGrid}>
 *      <div className={tableGridHeader}>
 *        <div className={tableGridCell}>Column 1</div>
 *        <div className={tableGridCell}>Column 2</div>
 *      </div>
 *      <div className={tableGridRow}>
 *        <div className={tableGridCell}>Value 1</div>
 *        <div className={tableGridCell}>Value 2</div>
 *      </div>
 *    </div>
 */

export const tableGrid = css`
  position: relative;
`;

export const tableGridHeader = css`
  position: sticky;
  z-index: 1;
  top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow:
    0 1px 4px 0 ${withVar(DesignToken.SurfaceTertiaryDefault)},
    inset 0 -1px 0 0 ${withVar(DesignToken.BorderBasicPrimary)},
    inset 0 1px 0 0 ${withVar(DesignToken.BorderBasicPrimary)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
`;

export const tableGridRow = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: solid 1px ${withVar(DesignToken.BorderBasicPrimary)};
`;

export const tableGridCell = css`
  position: relative;
  flex: 0 0 auto;
`;
